<template>
    <v-container colum fluid fill-height>
        <v-row>
            <v-col>
                <v-card>
                    <v-toolbar color="secondary" dark>
                    <v-toolbar-title>
                        <v-icon left>mdi-handshake</v-icon>Suppliers
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items class="hidden-sm-and-down">
                        <AddSupplier @added="getList" />
                    </v-toolbar-items>
                    </v-toolbar>
                    <v-data-table
                        :headers="headers"
                        :items="list"
                        :loading="loading"
                        :options.sync="options"
                        :server-items-length="totalCount"
                        >
                        <template v-slot:item.actions="{item}">
                            <v-btn text icon :to="'/inventory/suppliers/'+item.id">
                                <v-icon small>mdi-eye</v-icon>
                            </v-btn>
                            <EditSupplier :supplier="item" @saved="getList" />
                            <DeleteSupplier :supplier="item" @saved="getList" />
                        </template>
                        <template v-slot:item.isEnabled="{item}">
                            {{item.isEnabled ? 'Yes':'No'}}
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import AddSupplier from '@components/supplier/Add'
import EditSupplier from '@components/supplier/Edit'
import DeleteSupplier from '@components/supplier/Delete'
export default {
    components:{
        AddSupplier,
        EditSupplier,
        DeleteSupplier
    },
    data: () => ({
        list:[],
        loading:true,
        headers: [
            { text: "Name", value: "name", align: "left" },
            { text: "Is Enabled ?", value: "isEnabled" },
            { text: "Actions", value: "actions", sortable: false }
        ],
        options: { itemsPerPage: 20, sortBy: ['name'], sortDesc: [true] },
        totalCount:0
    }),
    mounted(){
        this.getList()
    },
    watch:{
        options:function(){
            this.getList()
        }
    },
    methods:{
        ...mapActions("supplier", {listSupplier:"list"}),
        getList(){
            this.listSupplier(
            {
                pagination: this.options,
                rows_per_page: this.options.rowsPerPage,
                search: this.search,
                filters: {},
            })
            .then(({suppliers}) => {
                this.list = suppliers.data
                this.totalCount=suppliers.total
            })
            .finally(() => {
                this.loading=false
            })
        }
    }
    
}
</script>

<style>

</style>